/**
 * Selector de Comuna - Región Metropolitana con Google Maps Autocomplete
 * Pasa datos directamente al checkout vía URL
 */

(function() {
  'use strict';

  const REGION_RM = 'Región Metropolitana';
  let autocomplete = null;
  let googleMapsLoaded = false;
  let sessionToken = null;
  let debounceTimer = null;

  // Lista completa de las 52 comunas de la Región Metropolitana
  const COMUNAS_RM = [
    'Cerrillos', 'Cerro Navia', 'Colina', 'Conchalí', 'El Bosque',
    'Estación Central', 'Huechuraba', 'Independencia', 'La Cisterna',
    'La Florida', 'La Granja', 'La Pintana', 'La Reina', 'Las Condes',
    'Lo Barnechea', 'Lo Espejo', 'Lo Prado', 'Macul', 'Maipú',
    'Ñuñoa', 'Pedro Aguirre Cerda', 'Peñalolén', 'Providencia',
    'Pudahuel', 'Puente Alto', 'Quilicura', 'Quinta Normal', 'Recoleta',
    'Renca', 'San Bernardo', 'San Joaquín', 'San Miguel', 'San Ramón',
    'Santiago', 'Vitacura',
    // Comunas adicionales de la Provincia de Chacabuco
    'Lampa', 'Tiltil',
    // Comunas adicionales de la Provincia de Cordillera
    'Pirque', 'San José de Maipo',
    // Comunas adicionales de la Provincia de Maipo
    'Buin', 'Calera de Tango', 'Paine',
    // Comunas adicionales de la Provincia de Melipilla
    'Alhué', 'Curacaví', 'María Pinto', 'Melipilla', 'San Pedro',
    // Comunas adicionales de la Provincia de Talagante
    'El Monte', 'Isla de Maipo', 'Padre Hurtado', 'Peñaflor', 'Talagante'
  ];

  /**
   * Analiza una dirección y la separa en address1 (calle + número) y address2 (info adicional)
   * @param {string} fullAddress - Dirección completa ingresada
   * @param {string} route - Nombre de la calle
   * @param {string} streetNumber - Número de la calle
   * @returns {Object} - {address1: string, address2: string}
   */
  function separarDireccion(fullAddress, route, streetNumber) {
    // Si no hay route o streetNumber, retornar todo en address1
    if (!route && !streetNumber) {
      return { address1: fullAddress.trim(), address2: '' };
    }

    // Construir la dirección base
    const baseAddress = route && streetNumber
      ? route + ' ' + streetNumber
      : (route || streetNumber || '');

    // Si la dirección completa es igual a la base, no hay address2
    if (fullAddress.trim().toLowerCase() === baseAddress.toLowerCase()) {
      return { address1: baseAddress, address2: '' };
    }

    /**
     * Limpia información de Google Maps que no queremos en address2
     */
    function limpiarInfoGoogleMaps(text) {
      let cleaned = text;

      // Eliminar código postal (números de 7 dígitos típicos de Chile)
      cleaned = cleaned.replace(/\b\d{7}\b/g, '');

      // Eliminar "Santiago" y sus variantes
      cleaned = cleaned.replace(/,?\s*Santiago\s*,?/gi, '');

      // Eliminar "Región Metropolitana" y sus variantes
      cleaned = cleaned.replace(/,?\s*Regi[óo]n\s+Metropolitana\s*,?/gi, '');

      // Eliminar "Chile"
      cleaned = cleaned.replace(/,?\s*Chile\s*,?/gi, '');

      // Eliminar nombres de comunas de la Región Metropolitana
      COMUNAS_RM.forEach(function(comuna) {
        const regex = new RegExp(',?\\s*' + comuna.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*,?', 'gi');
        cleaned = cleaned.replace(regex, '');
      });

      // Limpiar comas, espacios y guiones sobrantes
      cleaned = cleaned.replace(/^[,\-\s]+|[,\-\s]+$/g, ''); // Inicio y final
      cleaned = cleaned.replace(/\s*,\s*,\s*/g, ', '); // Comas duplicadas
      cleaned = cleaned.replace(/\s{2,}/g, ' '); // Espacios múltiples

      return cleaned.trim();
    }

    // Crear un patrón que busque el número de calle seguido de información adicional
    const streetPattern = new RegExp(
      '(' + (route ? route.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : '') +
      '\\s*' + (streetNumber ? streetNumber.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : '') + ')' +
      '\\s*[,\\-]?\\s*(.+)',
      'i'
    );

    const match = fullAddress.match(streetPattern);

    if (match && match[2]) {
      // Hay información adicional después de la dirección base
      const rawAddress2 = match[2].trim();

      // Limpiar información de Google Maps
      const cleanedAddress2 = limpiarInfoGoogleMaps(rawAddress2);

      return {
        address1: baseAddress,
        address2: cleanedAddress2
      };
    }

    // Si no se encontró un patrón claro, intentar separar manualmente
    // buscando donde termina el número de calle
    if (streetNumber && fullAddress.includes(streetNumber)) {
      const parts = fullAddress.split(streetNumber);
      if (parts.length > 1 && parts[1].trim()) {
        // Hay algo después del número
        const afterNumber = parts[1].trim();
        // Remover comas o guiones al inicio
        const cleaned = afterNumber.replace(/^[,\-\s]+/, '');

        // Limpiar información de Google Maps
        const cleanedAddress2 = limpiarInfoGoogleMaps(cleaned);

        if (cleanedAddress2) {
          return {
            address1: baseAddress,
            address2: cleanedAddress2
          };
        }
      }
    }

    // Por defecto, retornar la base en address1
    return { address1: baseAddress, address2: '' };
  }

  function poblarComunas() {
    const selector = document.getElementById('select-comuna-rm');
    if (!selector || selector.options.length > 1) return;

    COMUNAS_RM.forEach(function(comuna) {
      const option = document.createElement('option');
      option.value = comuna;
      option.textContent = comuna;
      selector.appendChild(option);
    });
  }

  function mostrarTarifas(comuna) {
    const selector = document.getElementById('select-comuna-rm');
    const costsDiv = document.getElementById('shipping-costs-rm');
    const ratesDisplay = document.getElementById('shipping-rates-rm-display');
    
    // Verificar si debe mostrar tarifas
    const showRates = selector && selector.getAttribute('data-show-rates') === 'true';
    
    if (!showRates || !costsDiv || !ratesDisplay) return;

    ratesDisplay.innerHTML = '<p style="font-size: 13px; color: #666;">Cargando...</p>';
    costsDiv.style.display = 'block';

    fetch('/cart/shipping_rates.json?shipping_address[country]=Chile&shipping_address[province]=' + encodeURIComponent(REGION_RM) + '&shipping_address[city]=' + encodeURIComponent(comuna))
      .then(function(r) { return r.json(); })
      .then(function(data) {
        const html = [];
        if (data.shipping_rates && data.shipping_rates.length > 0) {
          data.shipping_rates.forEach(function(rate) {
            let precioNumerico = parseFloat(rate.price);
            
            const price = precioNumerico === 0 
              ? 'Gratis' 
              : new Intl.NumberFormat('es-CL', {
                  style: 'currency', 
                  currency: 'CLP', 
                  minimumFractionDigits: 0
                }).format(precioNumerico);
            
            html.push('<p style="font-size: 13px; margin: 4px 0; padding: 6px 8px; background: rgba(0,0,0,0.02); border-radius: 4px;"><strong>' + rate.presentment_name + ':</strong> ' + price + '</p>');
          });
          ratesDisplay.innerHTML = html.join('');
        } else {
          ratesDisplay.innerHTML = '<p style="font-size: 13px; color: #e53e3e;">No disponible</p>';
        }
      })
      .catch(function(err) {
        ratesDisplay.innerHTML = '<p style="font-size: 13px; color: #e53e3e;">Error al cargar</p>';
      });
  }

  function loadGoogleMapsAPI(apiKey, callback) {
    if (googleMapsLoaded || (window.google && window.google.maps && window.google.maps.places)) {
      callback();
      return;
    }

    window.initGoogleMaps = function() {
      googleMapsLoaded = true;
      callback();
    };

    window.gm_authFailure = function() {
      const input = document.getElementById('autocomplete-address-rm');
      if (input) {
        input.disabled = false;
        input.placeholder = 'Error con Google Maps - ingresa dirección manualmente';
      }
    };

    const script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&libraries=places&callback=initGoogleMaps&language=es&region=CL&loading=async';
    script.async = true;
    script.defer = true;
    script.onerror = function() {
      const input = document.getElementById('autocomplete-address-rm');
      if (input) {
        input.disabled = false;
        input.placeholder = 'Ingresa tu dirección manualmente';
      }
    };
    document.head.appendChild(script);
  }

  function initAutocomplete() {
    try {
      const input = document.getElementById('autocomplete-address-rm');
      if (!input) {
        return;
      }

      if (!window.google || !window.google.maps || !window.google.maps.places) {
        return;
      }

      // Crear session token para agrupar llamadas y reducir costos
      sessionToken = new google.maps.places.AutocompleteSessionToken();

      // Bounds de la Región Metropolitana completa (52 comunas)
      const rmBounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(-34.3, -71.5), // Suroeste (San Bernardo, Melipilla)
        new google.maps.LatLng(-32.9, -70.3)  // Noreste (Colina, San José de Maipo)
      );

      // Usar AutocompleteService para control total sobre las llamadas (debounce + min chars)
      const autocompleteService = new google.maps.places.AutocompleteService();
      const placesService = new google.maps.places.PlacesService(document.createElement('div'));

      let selectedPlaceId = null;

      // Configurar opciones de búsqueda optimizadas
      const searchOptions = {
        types: ['geocode'],
        componentRestrictions: { country: 'CL' },
        bounds: rmBounds,
        strictBounds: true,
        sessionToken: sessionToken
      };

      // Implementar debounce (300ms) y mínimo de caracteres (3) para optimizar costos
      input.addEventListener('input', function(e) {
        const currentValue = e.target.value.trim();

        // Limpiar timer anterior
        if (debounceTimer) {
          clearTimeout(debounceTimer);
        }

        // Limpiar sugerencias anteriores
        const existingDropdown = document.querySelector('.rm-autocomplete-dropdown');
        if (existingDropdown) {
          existingDropdown.remove();
        }

        // Si hay menos de 3 caracteres, no hacer nada
        if (currentValue.length < 3) {
          return;
        }

        // Esperar 300ms después de que el usuario deje de escribir
        debounceTimer = setTimeout(function() {
          // Hacer la llamada a la API con las optimizaciones
          autocompleteService.getPlacePredictions(
            Object.assign({}, searchOptions, { input: currentValue }),
            function(predictions, status) {
              if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
                return;
              }

              // Filtrar solo las direcciones que pertenecen a comunas de la RM
              const predictionsFiltradas = predictions.filter(function(prediction) {
                const description = prediction.description.toLowerCase();

                // Verificar si la descripción contiene alguna comuna de la RM
                return COMUNAS_RM.some(function(comuna) {
                  return description.includes(comuna.toLowerCase());
                });
              });

              if (predictionsFiltradas.length === 0) {
                return;
              }

              mostrarSugerencias(predictionsFiltradas, input);
            }
          );
        }, 300);
      });

      // Función para mostrar las sugerencias en un dropdown personalizado
      function mostrarSugerencias(predictions, inputElement) {
        // Limpiar dropdown anterior
        const existingDropdown = document.querySelector('.rm-autocomplete-dropdown');
        if (existingDropdown) {
          existingDropdown.remove();
        }

        // Crear dropdown
        const dropdown = document.createElement('div');
        dropdown.className = 'rm-autocomplete-dropdown';
        dropdown.style.cssText = 'position: absolute; background: white; border: 1px solid #ccc; border-top: none; width: ' + inputElement.offsetWidth + 'px; max-height: 200px; overflow-y: auto; z-index: 1000; box-shadow: 0 2px 6px rgba(0,0,0,0.3); border-radius: 0 0 4px 4px;';

        predictions.forEach(function(prediction) {
          const item = document.createElement('div');
          item.textContent = prediction.description;
          item.style.cssText = 'padding: 10px; cursor: pointer; border-bottom: 1px solid #f0f0f0;';
          item.setAttribute('data-place-id', prediction.place_id);

          item.addEventListener('mouseenter', function() {
            this.style.backgroundColor = '#f5f5f5';
          });

          item.addEventListener('mouseleave', function() {
            this.style.backgroundColor = 'white';
          });

          item.addEventListener('click', function() {
            const placeId = this.getAttribute('data-place-id');
            seleccionarLugar(placeId, prediction.description, inputElement);
            dropdown.remove();
          });

          dropdown.appendChild(item);
        });

        // Posicionar el dropdown
        inputElement.parentNode.appendChild(dropdown);
        const rect = inputElement.getBoundingClientRect();
        dropdown.style.top = inputElement.offsetTop + inputElement.offsetHeight + 'px';
        dropdown.style.left = inputElement.offsetLeft + 'px';

        // Cerrar al hacer click fuera
        setTimeout(function() {
          document.addEventListener('click', function cerrarDropdown(e) {
            if (!dropdown.contains(e.target) && e.target !== inputElement) {
              dropdown.remove();
              document.removeEventListener('click', cerrarDropdown);
            }
          });
        }, 100);
      }

      // Función para obtener detalles del lugar seleccionado
      function seleccionarLugar(placeId, description, inputElement) {
        inputElement.value = description;

        placesService.getDetails(
          {
            placeId: placeId,
            fields: ['address_components', 'formatted_address'],
            sessionToken: sessionToken
          },
          function(place, status) {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
              procesarLugarSeleccionado(place, inputElement);

              // Regenerar session token después de obtener detalles
              sessionToken = new google.maps.places.AutocompleteSessionToken();
              searchOptions.sessionToken = sessionToken;
            }
          }
        );
      }

      // Procesar el lugar seleccionado (extraer componentes)
      function procesarLugarSeleccionado(place, inputElement) {
        if (!place.address_components) {
          return;
        }

        let streetNumber = '';
        let route = '';
        let comuna = '';

        // Extraer componentes de la dirección
        place.address_components.forEach(function(component) {
          const types = component.types;

          if (types.includes('street_number')) {
            streetNumber = component.long_name;
          }
          if (types.includes('route')) {
            route = component.long_name;
          }
          if (types.includes('locality') || types.includes('administrative_area_level_3')) {
            comuna = component.long_name;
          }
        });

        // Guardar componentes básicos en campos hidden
        const streetNumberInput = document.getElementById('address-street-number');
        const routeInput = document.getElementById('address-route');

        if (streetNumberInput) streetNumberInput.value = streetNumber;
        if (routeInput) routeInput.value = route;

        // Auto-seleccionar comuna si existe en la lista
        const selector = document.getElementById('select-comuna-rm');
        if (selector && comuna) {
          const comunaNormalized = comuna.trim();

          // Buscar la comuna en las opciones del selector
          for (let i = 0; i < selector.options.length; i++) {
            if (selector.options[i].value.toLowerCase() === comunaNormalized.toLowerCase()) {
              selector.value = selector.options[i].value;
              selector.dispatchEvent(new Event('change'));
              break;
            }
          }
        }
      }

      // Escuchar cambios en el input para detectar información adicional agregada manualmente
      input.addEventListener('blur', function() {
        const fullAddress = input.value.trim();
        if (!fullAddress) return;

        const streetNumberInput = document.getElementById('address-street-number');
        const routeInput = document.getElementById('address-route');
        const address2Input = document.getElementById('address-line2');

        const streetNumber = streetNumberInput ? streetNumberInput.value : '';
        const route = routeInput ? routeInput.value : '';

        // Separar la dirección en address1 y address2
        const separated = separarDireccion(fullAddress, route, streetNumber);

        // Guardar address2 si existe
        if (address2Input) {
          address2Input.value = separated.address2;
        }
      });

    } catch(error) {
      // Error al inicializar autocomplete
    }
  }

  function configurarSubmit() {
    const btn = document.getElementById('checkout-submit');
    if (!btn) return;

    btn.addEventListener('click', function(e) {
      const selector = document.getElementById('select-comuna-rm');
      const addressInput = document.getElementById('autocomplete-address-rm');

      // Validación desactivada - los campos no son obligatorios
      // if (!selector || !selector.value) {
      //   e.preventDefault();
      //   e.stopPropagation();
      //   alert('Por favor, selecciona tu comuna antes de continuar.');
      //   if (selector) selector.focus();
      //   return false;
      // }

      // Verificar si el autocomplete está habilitado
      const container = selector ? selector.closest('[data-google-api-key]') : null;
      const enableAutocomplete = container && container.getAttribute('data-enable-autocomplete') === 'true';

      // Validación de dirección desactivada - no es obligatoria
      // const addressInput = document.getElementById('autocomplete-address-rm');
      // if (enableAutocomplete && addressInput) {
      //   if (!addressInput.value || addressInput.value.trim() === '') {
      //     e.preventDefault();
      //     e.stopPropagation();
      //     alert('Por favor, ingresa tu dirección antes de continuar.');
      //     addressInput.focus();
      //     return false;
      //   }
      // }

      // Construir la dirección completa
      const streetNumber = document.getElementById('address-street-number');
      const route = document.getElementById('address-route');
      const address2Input = document.getElementById('address-line2');

      let address1 = '';
      let address2 = '';

      // Si tenemos route y streetNumber, construir address1
      if (route && route.value && streetNumber && streetNumber.value) {
        address1 = route.value + ' ' + streetNumber.value;
      } else if (addressInput && addressInput.value) {
        // Si no se detectaron componentes, analizar manualmente
        const separated = separarDireccion(addressInput.value, '', '');
        address1 = separated.address1;
        address2 = separated.address2;
      }

      // Obtener address2 del campo hidden si existe
      if (address2Input && address2Input.value) {
        address2 = address2Input.value;
      } else if (!address2 && addressInput && addressInput.value) {
        // Si no hay address2 guardado, intentar separar de nuevo
        const fullAddress = addressInput.value;
        const routeValue = route ? route.value : '';
        const streetNumberValue = streetNumber ? streetNumber.value : '';

        if (routeValue || streetNumberValue) {
          const separated = separarDireccion(fullAddress, routeValue, streetNumberValue);
          address2 = separated.address2;
        }
      }

      const form = btn.form || document.querySelector('form');
      if (form && selector && selector.value) {
        let checkoutUrl = '/checkout?checkout[shipping_address][country]=CL&checkout[shipping_address][province]=' + encodeURIComponent(REGION_RM) + '&checkout[shipping_address][city]=' + encodeURIComponent(selector.value);

        // Agregar dirección principal si existe
        if (address1) {
          checkoutUrl += '&checkout[shipping_address][address1]=' + encodeURIComponent(address1);
        }

        // Agregar dirección secundaria si existe
        if (address2) {
          checkoutUrl += '&checkout[shipping_address][address2]=' + encodeURIComponent(address2);
        }

        form.setAttribute('action', checkoutUrl);
      }
    });
  }

  function init() {
    const selector = document.getElementById('select-comuna-rm');
    if (!selector) return;

    poblarComunas();

    selector.addEventListener('change', function() {
      if (this.value) {
        mostrarTarifas(this.value);
      } else {
        const costsDiv = document.getElementById('shipping-costs-rm');
        if (costsDiv) costsDiv.style.display = 'none';
      }
    });

    configurarSubmit();

    // Inicializar Google Maps Autocomplete si está habilitado
    const container = selector.closest('[data-google-api-key]');
    if (container) {
      const apiKey = container.getAttribute('data-google-api-key');
      const enableAutocomplete = container.getAttribute('data-enable-autocomplete') === 'true';

      if (enableAutocomplete && apiKey && apiKey.trim() !== '') {
        loadGoogleMapsAPI(apiKey, initAutocomplete);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart:open', init);
  document.addEventListener('drawer:open', init);
})();
